/** Teksty nagłówka widoku „Hero 2.0” (kafelki, wniosek, zwijanie). */
export const heroPl = {
  live: 'Na żywo',
  updated: 'aktualizacja {time}',
  refresh: 'Odśwież dane',
  collapse: 'Zwiń nagłówek',
  expand: 'Rozwiń nagłówek',
  vsPrev: 'vs poprz.',
};

export const heroEn: typeof heroPl = {
  live: 'Live',
  updated: 'updated {time}',
  refresh: 'Refresh data',
  collapse: 'Collapse header',
  expand: 'Expand header',
  vsPrev: 'vs prev.',
};
